<template>
    <div class="container">
        <h2 class="title"> {{ $t('home.quran_programs.title') }}</h2>
        <router-link to="/quran_programs" class="view-all">  {{ $t('home.quran_programs.show_all') }}</router-link>
        <div class="main-row row">
            <div class="col-lg-4 col-12" v-for="(item, index) in programs" :key="index">
                <QuranProgramCard :item="item"/>
        
            </div>
        </div>
    </div>
</template>

<script>
import QuranProgramCard from "../QuranPrograms/QuranProgramCard.vue"

export default {
    props: {
        programs: {
            type: Array, // Adjust type based on your data structure
            required: true // Set to false if it's optional
        }
    },
    components : {
        QuranProgramCard
    }
}
</script>

<style scoped>
.container {
    margin-top: 40px;

}

.title {
    font-size: 36px;
    font-weight: 500;
    display: inline;
}

.view-all {
    font-size: 20px;
    font-weight: 500;
    color: #BF9F35;
    /* Gold color */
    text-decoration: none;
    float: inline-end;
    text-decoration: underline;
    cursor: pointer;
}

.main-row {
    margin-top: 40px;
}




</style>
